import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { InstallOptionEnum } from '@ffd/api-client';
import { SiteSetupComponentService, StepNumberEnum } from '../site-setup/site-setup.component.service';
import { SiteSetupNavbarComponent } from '../site-setup/components/site-setup-navbar/site-setup-navbar.component';

@Component({
  selector: 'lib-install-options',
  imports: [CommonModule, SiteSetupNavbarComponent, TranslatePipe, SvgIconComponent],
  templateUrl: './install-options.component.html',
  styleUrl: './install-options.component.scss',
})
export class InstallOptionsComponent {
  private readonly service = inject(SiteSetupComponentService);

  protected readonly vm = this.service.viewModel;
  protected readonly StepNumberEnum = StepNumberEnum;
  protected readonly InstallOptionEnum = InstallOptionEnum;

  protected selection: InstallOptionEnum | null = null;
  protected submitted = false;

  protected select(option: InstallOptionEnum): void {
    this.selection = option;
  }

  protected next(): void {
    this.submitted = true;
    if (!this.selection) {
      return;
    }

    // Both paths persist a step and navigate on: contact -> terminal ItProviderContacted screen,
    // self-install -> the server-installation checklist. No local terminal state needed here.
    if (this.selection === InstallOptionEnum.CONTACT_IT_PROVIDER) {
      this.service.chooseContactItProvider(this.vm().itProviderDraft);
    } else {
      this.service.chooseSelfInstall(this.vm().itProviderDraft);
    }
  }
}
